import { useState } from "react";
import { connect } from "react-redux";
import {
  Section,
  LayoutContainer
} from "../../../../components/CustomLayout/CustomLayoutStyles";
import TittleLine from "../../../../components/Common/TittleLine";
import CheckRender from "../../../../components/Common/CheckRender";
import CustomAlert from "../../../../components/Common/CustomAlert";
import { useUpdateEffect } from "../../../../hooks/LifeCycle";
import ModalLoader from "../../../../components/Common/ModalLoader";
import CustomButton from "../../../../components/CustomButton/CustomButton";
import useEmpresa from "../../../../hooks/useEmpresa";
import Colors from "../../../../themes/Colors";
import { useHistory } from "react-router-dom";
import standVirtualRoutes from "../../standVirtualRoutes";
import { MainContent } from "../../styles/MainLayoutStandVirtualStyles";
import CustomMainNavBar from "../../../../components/CustomHeader/CustomMainNavBar";

import AseguradoActions from "../../../../stores/asegurado/Actions";
import precertificacionTypes from "../../../../stores/precertificacion/Actions";
import coberturaTypes from "../../../../stores/cobertura/Actions";
import { tipoDocumentoCedula, tipoDocumentoCarnet } from "../../constantes";
import { datosCertificacionInicial } from "../estadoInicial";
import { isObjectEmpty } from "../../../../utils/ObjectUtil";
import { isValidPhone, isValidEmail } from "../../../../utils/ValidationUtil";
import { localToNumber } from "../../../../utils/NumberUtil";

import PrecertificacionBuscarAfiliado from "../components/PrecertificacionBuscarAfiliado";
import PrecertificacionDatosAfiliado from "../components/PrecertificacionDatosAfiliado";
import PrecertificacionDatosSolicitud from "../components/PrecertificacionDatosSolicitud";
import PrecertificacionProcedimientos from "../components/PrecertificacionProcedimientos";
import PrecertificacionAdjuntos from "../components/PrecertificacionAdjuntos";
import EmpresaUtil from "../../../../utils/EmpresaUtil";
import { cleanNumber } from "../../../../utils/NumberUtil";

const PrecertificacionCrearScreen = (props) => {
  const empresa = useEmpresa();
  const history = useHistory();
  const [afiliado, setAfiliado] = useState(null);
  const [alertConfig, setAlertConfig] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [tiposSolicitudes, setTiposSolicitudes] = useState([]);
  const [coberturas, setCoberturas] = useState([]);
  const [coberturasSeleccionadas, setCoberturasSeleccionadas] = useState([]);
  const [documentos, setDocumentos] = useState([]);
  const [datosCertificacion, setDatosCertificacion] = useState({
    ...datosCertificacionInicial
  });

  const goTo = (path) => {
    history.push(path);
  };

  const handleDatosCertificacionStateChange =
    (key, format = null) =>
    (value) => {
      setDatosCertificacion((prevState) => {
        return {
          ...prevState,
          [key]: format
            ? format(value)
            : key === "telefono"
              ? cleanNumber(value)
              : value
        };
      });
    };

  const mostrarAlerta = (mensaje, tipo = "info", titulo = "¡Hola!") => {
    setAlertConfig({
      type: tipo,
      title: titulo,
      message: mensaje,
      onConfirm: () => {
        setShowAlert(false);
      }
    });
    setShowAlert(true);
  };

  const mostrarError = (mensaje) => {
    mostrarAlerta(mensaje, "error", "¡Error!");
  };

  const handleBuscarAfiliado = (numeroPlastico) => {
    const { numeroSesionReutilizable: numeroSesion } = props?.authUserData;
    props.consultarAsegurado({
      numeroSesion,
      numeroPlastico
    });
  };

  const handleCoberturaSeleccionada = (cobertura) => {
    if (!cobertura) return;

    if (
      coberturasSeleccionadas.some(
        (item) => item.codigoCobertura === cobertura.codigoCobertura
      )
    ) {
      mostrarError(
        "El procedimiento ya fue seleccionado, por favor seleccione otro"
      );
      return;
    }

    setCoberturasSeleccionadas((prevState) => {
      return [...prevState, cobertura];
    });

    props.obtenerCoberturaDocumentos({
      tipoProcedimiento: cobertura.tipoProcedimiento,
      cobertura: cobertura.codigoCobertura
    });
  };

  const handleArchivoSeleccionado = (documento, archivo) => {
    if (!documento || !archivo) return;

    setDocumentos((prevState) => {
      const index = prevState.findIndex(
        (item) =>
          item.documento === documento.documento &&
          item.cobertura === documento.cobertura &&
          item.tipoProcedimiento === documento.tipoProcedimiento
      );

      if (index !== -1) {
        const updatedDocumentos = [...prevState];
        updatedDocumentos[index] = { ...updatedDocumentos[index], archivo };
        return updatedDocumentos;
      }
      return prevState;
    });
  };

  const handleEliminarCoberturaSeleccionada = (cobertura) => {
    if (!cobertura) return;

    console.log("Eliminar cobertura:", cobertura);

    setAlertConfig({
      type: "confirm",
      title: "Confirmación",
      message:
        "¿Está seguro de que desea eliminar el procedimiento seleccionado?",
      onConfirm: () => {
        setShowAlert(false);
        setCoberturasSeleccionadas((prevState) => {
          const index = prevState.findIndex(
            (item) =>
              item.codigoCobertura === cobertura.codigoCobertura &&
              item.tipoProcedimiento === cobertura.tipoProcedimiento
          );

          if (index === -1) return prevState;
          const updatedCoberturas = [...prevState];
          updatedCoberturas.splice(index, 1);
          return updatedCoberturas;
        });

        setDocumentos((prevState) => {
          const index = prevState.findIndex(
            (item) =>
              item.cobertura === cobertura.codigoCobertura &&
              item.tipoProcedimiento === cobertura.tipoProcedimiento
          );

          if (index === -1) return prevState;

          const totalDocumento = prevState.filter(
            (item) =>
              item.cobertura === cobertura.codigoCobertura &&
              item.tipoProcedimiento === cobertura.tipoProcedimiento
          ).length;

          const updatedDocumentos = [...prevState];
          updatedDocumentos.splice(index, totalDocumento);
          return updatedDocumentos;
        });
      },
      onCancel: () => {
        setShowAlert(false);
      }
    });

    setShowAlert(true);
  };

  const limpiarFormulario = () => {
    setAfiliado(null);
    setCoberturas([]);
    setCoberturasSeleccionadas([]);
    setDocumentos([]);
    setDatosCertificacion({ ...datosCertificacionInicial });
    setTiposSolicitudes([]);
  };

  const handleCancelar = () => {
    setAlertConfig({
      type: "confirm",
      title: "Confirmación",
      message: "¿Está seguro de que desea cancelar?",
      onConfirm: () => {
        setShowAlert(false);
        limpiarFormulario();
      },
      onCancel: () => {
        setShowAlert(false);
      }
    });

    setShowAlert(true);
  };

  const handleEnviarSolicitud = () => {
    if (!handleValidarDatosBasicos()) return;

    if (!coberturasSeleccionadas || coberturasSeleccionadas.length === 0) {
      mostrarError("Debe seleccionar al menos un procedimiento");
      return;
    }

    console.log("documentos before send:", documentos);

    if (
      documentos &&
      documentos.some((item) => item.requerido && item.archivo === null)
    ) {
      mostrarError(
        "Debe adjuntar los documentos requeridos marcados con asterisco (*)"
      );
      return;
    }

    setAlertConfig({
      type: "confirm",
      title: "Confirmación",
      message: "¿Está seguro de que desea enviar la solicitud?",
      onConfirm: () => {
        setShowAlert(false);
        const { numeroSesionReutilizable: numeroSesion } = props?.authUserData;

        const datosSolicitud = {
          numeroSesion,
          informacion: datosCertificacion,
          documentos: documentos.filter((item) => item.archivo !== null),
          coberturas: coberturasSeleccionadas,
          afiliado,
          compania: empresa?.CODIGO
        };

        props.crearPrecertificacion(datosSolicitud);
      },
      onCancel: () => {
        setShowAlert(false);
      }
    });
    setShowAlert(true);
  };

  const handleValidarDatosBasicos = () => {
    if (!datosCertificacion.tipoSolicitud) {
      mostrarError("Tipo de solicitud es requerido");
      return false;
    }

    if (
      !datosCertificacion.telefono ||
      !isValidPhone(datosCertificacion.telefono)
    ) {
      mostrarError("Teléfono es requerido y debe ser válido");
      return false;
    }

    if (
      !datosCertificacion.correo ||
      !isValidEmail(datosCertificacion.correo)
    ) {
      mostrarError("Correo electrónico es requerido y debe ser válido");
      return false;
    }

    if (!datosCertificacion.medicoPrescriptor) {
      mostrarError("Médico prescriptor es requerido");
      return false;
    }
    if (!datosCertificacion.diagnostico) {
      mostrarError("Diagnóstico es requerido");
      return false;
    }

    return true;
  };

  const handleMisSolicitudes = () => {
    const createNewRequest = `/${standVirtualRoutes.base.route}/${standVirtualRoutes.precertificacion.route}`;
    goTo(createNewRequest);
  };

  //Mostrar alerta de error
  useUpdateEffect(() => {
    if (
      props.consultarAseguradoError ||
      props.tiposSolicitudesPrecertificacionError ||
      props.coberturasConfiguradasPssError ||
      props.obtenerCoberturaDocumentosError ||
      props.crearCertificacionError
    ) {
      const { mensaje } =
        props.consultarAseguradoError ||
        props.tiposSolicitudesPrecertificacionError ||
        props.coberturasConfiguradasPssError ||
        props.obtenerCoberturaDocumentosError ||
        props.crearCertificacionError;
      mostrarError(mensaje);
    }
  }, [
    props.consultarAseguradoError,
    props.tiposSolicitudesPrecertificacionError,
    props.coberturasConfiguradasPssError,
    props.obtenerCoberturaDocumentosError || props.crearCertificacionError
  ]);

  //Cargar tipos de solicitudes
  useUpdateEffect(() => {
    if (props.tiposSolicitudesPrecertificacionData === undefined) return;

    if (
      !props.tiposSolicitudesPrecertificacionData ||
      props.tiposSolicitudesPrecertificacionData.length === 0
    ) {
      setAfiliado(null);
      mostrarError(
        "No se pudo cargar los tipos de solicitudes, por favor intente nuevamente"
      );
      return;
    }
    setTiposSolicitudes(props.tiposSolicitudesPrecertificacionData);
  }, [props.tiposSolicitudesPrecertificacionData]);

  //Cargar coberturas configuradas PSS
  useUpdateEffect(() => {
    if (props.tiposSolicitudesPrecertificacionData === undefined) return;
    if (
      !props.coberturasConfiguradasPssData ||
      props.coberturasConfiguradasPssData.length === 0
    ) {
      setCoberturas([]);
      mostrarError(
        "Pss no tiene coberturas configuradas, favor contactar a su ejecutivo"
      );
      return;
    }
    setCoberturas(props.coberturasConfiguradasPssData);
  }, [props.coberturasConfiguradasPssData]);

  //Cargar documentos cobertura
  useUpdateEffect(() => {
    if (
      !props.obtenerCoberturaDocumentosData ||
      props.obtenerCoberturaDocumentosData.length === 0
    )
      return;
    props.obtenerCoberturaDocumentosData.forEach((item) => {
      if (
        [tipoDocumentoCedula, tipoDocumentoCarnet].includes(item.documento) &&
        documentos.some((doc) => doc.documento === item.documento)
      )
        return;

      setDocumentos((prevState) => {
        return [
          ...prevState,
          {
            ...item,
            archivo: null,
            nombreProcedimiento: coberturasSeleccionadas.find(
              (cobertura) => cobertura.codigoCobertura === item.cobertura
            )?.nombreCobertura,
            cobertura: [tipoDocumentoCedula, tipoDocumentoCarnet].includes(
              item.documento
            )
              ? null
              : item.cobertura
          }
        ];
      });
    });
  }, [props.obtenerCoberturaDocumentosData]);

  //Cargar informacion asegurado
  useUpdateEffect(() => {
    if (isObjectEmpty(props.consultarAseguradoData)) return;

    const { afiliado, compania } = props.consultarAseguradoData;

    if (!afiliado.vigente) {
      mostrarError(
        `El ${
          empresa.CODIGO === EmpresaUtil["96"].CODIGO ? "asegurado" : "afiliado"
        } no está vigente en este plan`
      );
      return;
    }

    if (localToNumber(empresa.CODIGO) !== compania.codigo) {
      mostrarError(
        <p>
          El número de
          {empresa.CODIGO === EmpresaUtil["96"].CODIGO
            ? "asegurado"
            : "afiliado"}{" "}
          digitado pertenece a {empresa.REDIRECT_COMPANY.NAME}, para procesar la
          solicitud de pre-certificación favor dirigirse a la página
          Autorizaciones (
          <a href={empresa.REDIRECT_COMPANY.URL} rel="noreferrer">
            {empresa.REDIRECT_COMPANY.NAME}
          </a>
          ) . Al hacer clic sobre el enlace la página lo debe re direccionar de
          manera automática
        </p>
      );
      return;
    }

    setAfiliado({
      ...afiliado,
      nombre: `${afiliado.nombres} ${afiliado.apellidos}`
    });

    if (tiposSolicitudes.length === 0)
      props.cargarTiposSolicitudesPrecertificacion();
    props.obtenerCoberturasConfiguradasPss();
  }, [props.consultarAseguradoData]);

  //enviar solicitud completado
  useUpdateEffect(() => {
    if (
      !props.crearCertificacionData ||
      isObjectEmpty(props.crearCertificacionData)
    )
      return;
    const { numeroSolicitud } = props.crearCertificacionData;
    setAlertConfig({
      type: "info",
      title: "!Información!",
      message: `Solicitud enviada ${numeroSolicitud}`,
      onConfirm: () => {
        setShowAlert(false);
      }
    });
    setShowAlert(true);
    limpiarFormulario();
  }, [props.crearCertificacionData]);

  useUpdateEffect(() => {
    if (coberturasSeleccionadas.length === 0) {
      setDocumentos([]);
    }
  }, [coberturasSeleccionadas]);

  useUpdateEffect(() => {
    setShowAlert(false);
    setAlertConfig({});
  }, []);

  return (
    <LayoutContainer>
      <CustomMainNavBar />
      <MainContent>
        <Section>
          <TittleLine
            title={"Solicitud de pre certificación"}
            customButton={
              <CustomButton
                label="Stand Virtual"
                bgColor={Colors.darkGreenPrimera}
                hoverColor={Colors.LightGreenPrimera}
                textColor={Colors.white}
                hoverTextColor={Colors.white}
                onClick={handleMisSolicitudes}
                width="200px"
                fontSize="16px"
              />
            }
          />
        </Section>

        <CheckRender
          allowed={
            !afiliado ||
            tiposSolicitudes.length === 0 ||
            coberturas.length === 0
          }
        >
          <PrecertificacionBuscarAfiliado
            mostrarAlerta={mostrarAlerta}
            cargando={props.consultarAseguradoLoading}
            buscar={handleBuscarAfiliado}
          />
        </CheckRender>

        <CheckRender
          allowed={
            afiliado && tiposSolicitudes.length > 0 && coberturas.length > 0
          }
        >
          <PrecertificacionDatosAfiliado afiliado={afiliado} />

          <PrecertificacionDatosSolicitud
            datosCertificacion={datosCertificacion}
            tiposSolicitudes={tiposSolicitudes}
            onFieldChange={handleDatosCertificacionStateChange}
          />

          <PrecertificacionProcedimientos
            coberturas={coberturas}
            cargando={props.obtenerCoberturaDocumentosLoading}
            coberturasSeleccionadas={coberturasSeleccionadas}
            onSeleccionarCobertura={handleCoberturaSeleccionada}
            onEliminarCobertura={handleEliminarCoberturaSeleccionada}
          />

          <CheckRender allowed={documentos.length > 0}>
            <PrecertificacionAdjuntos
              documentos={documentos}
              onArchivoSeleccionado={handleArchivoSeleccionado}
              onError={mostrarError}
            />
          </CheckRender>

          <Section gap={"10px"} marginTop={"20px"}>
            <CustomButton
              label={"Enviar Solicitud"}
              width={"200px"}
              onClick={handleEnviarSolicitud}
              isLoading={props.crearCertificacionLoading}
            />
            <CustomButton
              label={"Cancelar"}
              width={"200px"}
              onClick={handleCancelar}
              disabled={props.crearCertificacionLoading}
            />
          </Section>
        </CheckRender>

        <CheckRender allowed={showAlert}>
          <CustomAlert {...alertConfig} />
        </CheckRender>

        <CheckRender
          allowed={
            props.consultarAseguradoLoading ||
            props.tiposSolicitudesPrecertificacionLoading ||
            props.coberturasConfiguradasPssLoading ||
            props.crearCertificacionLoading
          }
        >
          <ModalLoader />
        </CheckRender>
      </MainContent>
    </LayoutContainer>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  //consultar asegurado
  consultarAseguradoData: state.asegurado.consultarAseguradoData,
  consultarAseguradoLoading: state.asegurado.consultarAseguradoLoading,
  consultarAseguradoError: state.asegurado.consultarAseguradoError,
  //tipos solicitudes precertificacion
  tiposSolicitudesPrecertificacionLoading:
    state.precertificacion.tiposSolicitudesPrecertificacionLoading,
  tiposSolicitudesPrecertificacionError:
    state.precertificacion.tiposSolicitudesPrecertificacionError,
  tiposSolicitudesPrecertificacionData:
    state.precertificacion.tiposSolicitudesPrecertificacionData,
  //coberturas contratadas PSS
  coberturasConfiguradasPssLoading:
    state.cobertura.obtenerCoberturasConfiguradasPssLoading,
  coberturasConfiguradasPssError:
    state.cobertura.obtenerCoberturasConfiguradasPssError,
  coberturasConfiguradasPssData:
    state.cobertura.obtenerCoberturasConfiguradasPssData,
  //documentos configurados cobertura
  obtenerCoberturaDocumentosLoading:
    state.cobertura.obtenerCoberturasConfiguradasDocumentosLoading,
  obtenerCoberturaDocumentosError:
    state.cobertura.obtenerCoberturasConfiguradasDocumentosError,
  obtenerCoberturaDocumentosData:
    state.cobertura.obtenerCoberturasConfiguradasDocumentosData,
  //crear certificacion
  crearCertificacionLoading:
    state.precertificacion.crearPrecertificacionLoading,
  crearCertificacionError: state.precertificacion.crearPrecertificacionError,
  crearCertificacionData: state.precertificacion.crearPrecertificacionData
});

const mapDispatchToProps = {
  consultarAsegurado: AseguradoActions.consultarAsegurado,
  cargarTiposSolicitudesPrecertificacion:
    precertificacionTypes.tiposSolicitudesPrecertificacion,
  obtenerCoberturasConfiguradasPss:
    coberturaTypes.obtenerCoberturasConfiguradasPss,
  obtenerCoberturaDocumentos:
    coberturaTypes.obtenerCoberturasConfiguradasDocumentos,
  crearPrecertificacion: precertificacionTypes.crearPrecertificacion
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(PrecertificacionCrearScreen);
